import React, { Component } from "react";

class PrivacyPolicyContent extends Component {
  render() {
    return (
      <section className="section testimonial-area ptb_100">
        <div className="container text-center">
          <div className="row justify-content-center align-items-center">
            <div className="col-12 col-md-10 col-lg-8">
              <h2 className="mt-4 mb-3">Privacy Policy</h2>
              {/* <p className="mb-3">Last Updated on December 29, 2025</p> */}
              <div className="col-12 col-md-12 row">
                <div style={{ textAlign: "start" }}>
                  We, Monk Capital Pvt Ltd (Reg. No. N-09.00457) with our
                  Corporate office at The Platina, B-406, Jayabheri Enclave,
                  Gachibowli, Hyderabad, Telangana - 500032, India (hereinafter
                  shall be referred to as "MoneyMonk" or "Us" or "We" or “Our”)
                  is a NBFC also referred as MCPL to offer lending and other
                  various financial services.
                  <br />
                  <br />
                  This Privacy Policy document (“Privacy Policy”) is published
                  in accordance with the provisions of Rule 4 (1) of the
                  Information Technology (Reasonable Security Practices and
                  Procedures and Sensitive Personal Data or Information) Rules,
                  2011 which requires the publishing of a privacy policy for
                  handling of or dealing in personal information including
                  sensitive personal data or information.
                  <br />
                  <br />
                  User shall mean any person/ persons, who visits, uses, deals
                  with and/ or transacts through the website / app or avails our
                  services and includes a browser.
                  <br />
                  <br />
                  By visiting the website, https://moneymonkapp.in/ (“Website”)
                  or the MoneyMonk mobile application (the “App”) (collectively,
                  the “Platform”) and availing the services provided by us
                  (“Services”) you agree to be bound by the terms and conditions
                  of this Privacy Policy.
                  <br />
                  <br />
                  This policy does not apply to third-party websites/
                  applications that are connected via links to the platform.
                  <br />
                  <br />
                  If you do not agree to this Policy or any part thereof, please
                  do not use/ access/ download or install the Platform or any
                  part thereof.
                  <br />
                  <br />
                  This policy is a part of the platform terms & conditions
                  located at
                  <a href="https://moneymonkapp.in/termsandcondtions">
                    https://moneymonkapp.in/termsandcondtions
                  </a>
                  and all capitalized terms under this policy that have not been
                  specifically defined herein shall have the meaning as ascribed
                  to it under the platform terms & conditions.
                  <br />
                  <br />
                  We may update this policy from time to time. while we will
                  always endeavour to notify you, you must periodically review
                  the policy for the latest information on our privacy
                  practices.
                </div>
                <h3 className="mt-4 mb-2">1. COLLECTION OF INFORMATION</h3>
                <p style={{ textAlign: "start" }}>
                  When you use our Platform, we collect and store your
                  information which is provided by you from time to time by
                  explicitly seeking permissions from you to get the required
                  information. Our primary goal in doing so is to provide you a
                  safe, efficient, smooth and customized experience and
                  Services. This allows us to provide services and features that
                  meets your needs, and to customize our Platform to make your
                  experience safer and easier and to improve the Services
                  provided by us. More importantly, we collect personal
                  information from you that we consider necessary for achieving
                  the aforementioned purpose.
                  <br />
                  <br />
                  In general, you can browse the website or App without
                  providing us any personal information. However, to create an
                  account on the Platform, you must provide us with certain
                  basic information required to provide customized services. The
                  following information we collect from you:
                  <ul style={{ padding: 20 }}>
                    <li className="mb-1">• Full name</li>
                    <li className="mb-1">• Phone number</li>
                    <li className="mb-1">• Email Address</li>
                    <li className="mb-1">• Gender</li>
                    <li className="mb-1">• Selfie</li>
                    <li className="mb-1">• Current and Permanent address</li>
                    <li className="mb-1">
                      • Family and Friend contact details
                    </li>

                    <li className="mb-1">• Education details</li>
                    <li className="mb-1">
                      • Identity details (PAN/Aadhaar/Voter)
                    </li>

                    <li className="mb-1">• Employment details</li>
                    <li className="mb-1">• Income details</li>
                    <li className="mb-1">
                      • Information from credit bureaus and customer service
                      providers
                    </li>

                    <li className="mb-1">
                      • Your Aadhaar Number on behalf of the financial lending
                      partners, at your sole discretion
                    </li>
                    <li className="mb-1">
                      • Other information that You provide when You write
                      directly to Us (including by e-mail) or provide Us over
                      telephone or while filling out any applications on the
                      Platform.
                    </li>
                  </ul>
                  <h5 className="fw-5" style={{ color: "#000" }}>
                    • The Non-Personal Information:
                  </h5>
                  <div className="mb-2"></div>
                  We automatically track certain information about you based
                  upon your behavior on our Platform. We use this information to
                  do internal research on our users’ demographics, interests,
                  and behavior to better understand, protect and serve our users
                  and improve our services. This information is compiled and
                  analyzed on an aggregated basis. We also collect your Internet
                  Protocol (IP) address and the URL used by you to connect your
                  computer to the internet, etc. This information may include
                  the URL that you just came from (whether this URL is on our
                  Website or not), which URL you next go to (whether this URL is
                  on our Website or not), your computer browser information, and
                  your IP address.
                  <br />
                  <br />
                  Cookies are small data files that a Website stores on Your
                  computer. We will use cookies on our Website similar to other
                  lending websites / apps and online marketplace websites /
                  apps. Use of this information helps Us identify You in order
                  to make our Website more user friendly. Most browsers will
                  permit You to decline cookies but if You choose to do this it
                  might affect service on some parts of Our Website. We retain
                  this information as necessary to resolve disputes, provide
                  customer support and troubleshoot problems as permitted by
                  law.
                  <br />
                  <br />
                  If you send us personal correspondence, such as emails or
                  letters, or if other users or third parties send us
                  correspondence about your activities or postings on the
                  Website, we collect such information into a file specific to
                  you.
                </p>
                <h5 className="fw-5 mt-3 mb-2" style={{ color: "#000" }}>
                  • The Non-Personal Information:
                </h5>
                <p style={{ textAlign: "start" }}>
                  Is collected by Us after You explicitly provide us consent or
                  is shared by You with Us pursuant to a clear disclosure - such
                  as name, address, phone number, email address etc as mentioned
                  in section 1. We will collect your personal information when
                  you:
                </p>
                <ol style={{ textAlign: "start" }}>
                  <li className="mb-1">1. Register on our Website or App.</li>
                  <li>
                    2. Applying for a loan product or facility through our
                    Platform.
                  </li>
                </ol>
                <h3 className="mt-4 mb-2">
                  Information that You provide to Us
                </h3>
                <p style={{ textAlign: "start" }}>
                  Mobile number is required as a part of the registration
                  process to access our service. We further collect other
                  identifiable information on the platform when you set up an
                  account with us as further detailed below.
                  <br />
                  <br />
                  While you can browse our Platform without being a registered
                  member as mentioned above, certain activities (such as
                  availing of loans from the third-party lenders on the
                  Platform) require registration and for you to provide the
                  above details. The Platform will clearly display the personal
                  information it is collecting from you, and you have the option
                  to not provide such personal information. However, this will
                  limit the services provided to you on the Platform.
                  <br />
                  <br />
                  Our App also collects mobile number for verification to check
                  the active SIM status on the device, uniquely identify you and
                  prevent frauds and unauthorized access.
                  <br />
                  <br />
                  As a part of our Video Know Your Customer (Video KYC) process,
                  collection of your personal information has become mandatory
                  to ensure the completion and authentication of your KYC. In
                  this regard, permissions for microphone, camera will be
                  mandatorily required.
                  <br />
                  <br />
                  The key information collected from the device is further
                  detailed below:
                </p>
                <h3 className="mt-4 mb-2">I. COLLECTION OF SMS INFORMATION</h3>
                <p style={{ textAlign: "start" }}>
                  Our app may collect and transmit to MoneyMonk servers, your
                  SMS data which helps us in identifying the various bank
                  accounts that you may be holding, cash flow patterns,
                  description and amount of the transactions for the purpose of
                  performing a credit risk underwriting and assessment. This
                  credit risk assessment enables us to perform a speedy loan
                  disbursal. This data may be collected even when the app is
                  closed or not in use.
                </p>
                <h3 className="mt-4 mb-2">II. INSTALLED APPLICATIONS</h3>
                <p style={{ textAlign: "start" }}>
                  Our app collects and transmits to MoneyMonk servers, metadata
                  information which includes the application name, package name,
                  installed time, updated time, version name and version code of
                  each installed application on your device. This data may be
                  collected even when the app is closed or not in use. This
                  helps us to assess your credit worthiness and provide you with
                  customized or pre-approved loan products.
                </p>
                <h3 className="mt-4 mb-2">III. PHONE (DEVICE INFORMATION)</h3>
                <p style={{ textAlign: "start" }}>
                  Our app collects and transmits to MoneyMonk servers, specific
                  information about your device including your hardware model,
                  build model, RAM, storage, unique device identifiers such as
                  IMEI, serial number, SSAID, AAID; SIM information that
                  includes number of SIMs, network operator, roaming state, MNC
                  and MCC codes, WIFI connection name and other information
                  which includes MAC address and mobile network information to
                  uniquely identify the devices and prevent unauthorized devices
                  acting on your behalf to minimize frauds. This data may be
                  collected even when the app is closed or not in use. This also
                  helps us in enriching your credit profile and assess more
                  accurately.
                </p>
                <h3 className="mt-4 mb-2">IV. LOCATION</h3>
                <p style={{ textAlign: "start" }}>
                  Our app collects and transmits to MoneyMonk servers, the
                  information about the approximate location of your device to
                  provide serviceability of your loan application, to reduce the
                  risk associated with your loan application. This also helps us
                  to verify the address, perform a quicker KYC process to make a
                  better credit risk decision.
                </p>
                <h3 className="mt-3 mb-2">V. USER PERSONAL INFORMATION</h3>
                <p style={{ textAlign: "start" }}>
                  Our app collects and transmits to MoneyMonk servers, the
                  information about the approximate location of your device to
                  provide serviceability of your loan application, to reduce the
                  risk associated with your loan application. This also helps us
                  to verify the address, perform a quicker KYC process to make a
                  better credit risk decision.
                </p>
                <h3 className="mt-4 mb-2">VI. CAMERA</h3>{" "}
                <p style={{ textAlign: "start" }}>
                  We require camera access so that you can easily scan or
                  capture required KYC documents and save time by allowing us to
                  auto-fill relevant data or to initiate an audio/video call for
                  KYC purpose, which may be stored for future verification
                  purpose. This ensures that you are provided with the best user
                  experience while using the application.
                </p>
                <h3 className="mt-4 mb-2">VII. MICROPHONE</h3>{" "}
                <p style={{ textAlign: "start" }}>
                  We require microphone permission to initiate two-way audio
                  communication as a part of KYC journey in accordance with the
                  V-CIP (Video KYC) process prescribed by RBI. This may be
                  stored for future verification and audit purposes
                </p>
                <h3
                  className="mt-4 mb-2"
                  style={{ textDecoration: "underline" }}
                >
                  From Third Parties
                </h3>{" "}
                <p style={{ textAlign: "start" }}>
                  We also collect your credit reports and credit data on your
                  behalf or on behalf of our financial partner in the event you
                  have applied for a loan / facility to the said financial
                  partner. In this regard, You:
                  <ol>
                    <li>
                      I. Authorize Us, to request and receive Your credit score
                      / report from credit information companies, now and on a
                      periodic basis, at its discretion until such time You
                      communicate in writing to Us to discontinue such requests.
                    </li>
                    <li>
                      II. Further fully understand that the purpose of this
                      credit score / report is to enable Us to make informed
                      lending decisions effectively and enable faster processing
                      of credit applications to help provide speedier access to
                      credit through our Platform..
                    </li>
                    <li>
                      III. Also understand that We may apply for the credit
                      score / report either ourselves directly or through any of
                      their partner tie ups who are members of credit
                      information companies, and fully authorize Us to share my
                      details with such partners.
                    </li>
                  </ol>
                </p>
                <h3
                  className="mt-4 mb-2"
                  style={{ textDecoration: "underline" }}
                >
                  LINK TO THIRD-PARTY SDK
                </h3>{" "}
                <p style={{ textAlign: "start" }}>
                  The App has a link to a registered third-party SDK which
                  collects data on our behalf and data is stored to a secured
                  server to perform a credit risk assessment. We ensure that our
                  third-party service provider takes extensive security measures
                  in order to protect your personal information against loss,
                  misuse or alteration of the data.
                  <br />
                  <br />
                  Our third-party service provider employs separation of
                  environments and segregation of duties and have strict
                  role-based access control on a documented, authorized,
                  need-to-use basis. The stored data is protected and stored by
                  application-level encryption. They enforce key management
                  services to limit access to data.
                  <br />
                  <br />
                  Furthermore, our registered third-party service provider
                  provides hosting security – they use industry-leading
                  anti-virus, anti-malware, intrusion prevention systems,
                  intrusion detection systems, file integrity monitoring, and
                  application control solutions.
                </p>
                <h3
                  className="mt-4 mb-2"
                  style={{ textDecoration: "underline" }}
                >
                  Other Information
                </h3>{" "}
                <p style={{ textAlign: "start" }}>
                  <ol>
                    <li>
                      I. Any other information that MoneyMonk is required to
                      collect as per specific mandate from any financial lending
                      partners or as a requirement under applicable law.
                    </li>
                    <li>
                      II. Information from You electronically - like the pages
                      viewed, how You navigate through the Website / Platform
                      and interact with webpages, etc.
                    </li>
                    <li>
                      III. Cookies are small data files that a Website / App
                      stores on Your computer. We will use cookies on our
                      Website / App similar to other lending websites / apps and
                      online marketplace websites / apps. Use of this
                      information helps Us identify You in order to make our
                      Platform more user friendly. Most browsers will permit You
                      to decline cookies but if You choose to do this it might
                      affect service on some parts of Our Website.
                    </li>
                    <li>
                      IV. We might also use other technology to track how You
                      interact with Platform and employ some third-party
                      agencies to use the data on Our behalf. The information We
                      collect about You will depend on the products and services
                      We offer or You avail, on an ongoing basis. The
                      information collected from You will be used in order to
                      effectively provide services to you. If you do not allow
                      us to collect all the information We request on the
                      Platform, We may not be able to deliver all of these
                      services effectively.
                    </li>
                  </ol>
                </p>
                <h3 className="mt-4 mb-2">
                  2. PURPOSE, USE AND DISCLOSURE OF INFORMATION
                </h3>{" "}
                <p style={{ textAlign: "start" }}>
                  We will use and retain Your information for such periods as
                  necessary to provide You the services on our Platform, to
                  comply with our legal obligations, to resolve disputes, and
                  enforce our agreements with you or the financing partners who
                  have advanced a loan to You.
                </p>
                <h3
                  className="mt-4 mb-2"
                  style={{ textDecoration: "underline" }}
                >
                  Use of Information:
                </h3>{" "}
                <p style={{ textAlign: "start" }}>
                  We use data collected to support our Product, MoneyMonk, as a
                  platform assists You to reach and select diversity of
                  third-party financial partners, along with their products, and
                  technically help you accomplish transaction with these
                  third-party financial partners. We may use the information
                  provided by You in the following ways:
                  <ul style={{ padding: 20 }}>
                    <li>• To establish identity and verify the same.</li>
                    <li>• Monitor, improve and administer our Platform.</li>
                    <li>
                      • Design and offer customized products and services
                      offered by our third-party financial partners.
                    </li>
                    <li>
                      • Analyze how the Platform is used, diagnose service or
                      technical problems and maintain security.
                    </li>
                    <li>
                      • Send communications and notifications to you or process
                      queries and applications that You have made on the
                      Platform.
                    </li>
                    <li>
                      Manage Our relationship with You and inform You about
                      other products or services We think You might find of some
                      use.
                    </li>
                    <li>
                      • Conduct data analysis in order to improve the Services
                      provided to the User.
                    </li>
                    <li>
                      • Use the User information in order to comply with country
                      laws and regulations.
                    </li>
                    <li>
                      • To conduct KYC for our third-party lending partners
                      based on the information shared by the User for the
                      provision of Services.
                    </li>
                    <li>
                      • Use the User information in other ways permitted by law
                      to enable You to take financial services from our lending
                      partners.
                    </li>
                  </ul>
                </p>
                <h3
                  className="mt-4 mb-2"
                  style={{ textDecoration: "underline" }}
                >
                  Disclosure of Information
                </h3>{" "}
                <p style={{ textAlign: "start" }}>
                  We may share Your information with third parties including our
                  regulated financial partners for provision of services on the
                  Platform and/or for facilitation of a loan / facility to a
                  User. We may also share Your information with third parties
                  under a confidentiality agreement for provision of services
                  which inter alia restricts such third parties from further
                  disclosing the information unless such disclosure is for the
                  purpose as detailed under that confidentiality agreement. We
                  will share Your information with third parties only in such
                  manner as described below:
                  <ul style={{ padding: 20 }}>
                    <li>
                      • We may disclose Your information to the financial
                      service providers, banks or NBFCs and Our third-party
                      partners for providing the Services as detailed under the
                      Terms & Conditions.
                    </li>
                    <li>
                      • We may share Your information with our third-party
                      partners in order to conduct data analysis in order to
                      serve You better and provide Services on our Platform.
                    </li>
                    <li>
                      • We may disclose Your information, without prior notice,
                      if We are under a duty to do so in order to comply with
                      any legal obligation or an order from the government
                      and/or a statutory authority, or in order to enforce or
                      apply Our terms of use or assign such information in the
                      course of corporate divestitures, mergers, or to protect
                      the rights, property, or safety of Us, Our users, or
                      others. This includes exchanging information with other
                      companies and organizations for the purposes of fraud
                      protection and credit risk reduction.
                    </li>
                    <li>
                      • We may also share the data / information with our
                      technology service providers to perform credit and know
                      your customer checks to facilitate a loan for the User
                      through a regulated financial partner.
                    </li>
                    <li>
                      • We and our affiliates may share Your information with
                      another business entity should we (or our assets) merge
                      with, or be acquired by that business entity, or
                      re-organization, amalgamation, restructuring of business
                      for continuity of business.
                    </li>
                  </ul>
                </p>
                <h3 className="mt-4 mb-2">3. STORAGE OF INFORMATION</h3>{" "}
                <p style={{ textAlign: "start" }}>
                  You further understand and agree that disbursement of a loan
                  does not automatically rescind the consents you have provided
                  to us under the Privacy Policy nor does deletion of your
                  account with the Platform. Any information provided to us is
                  retained by Us until You have an account based / active
                  relationship with us or with a financial partner.
                  <br />
                  <br />
                  We store and process Your personal information on secure AWS
                  cloud servers and other cloud service providers within India.
                  Some of the safeguards We use are firewalls and encryption
                  using SSL, and information access authorization controls. We
                  use reasonable safeguards to preserve the integrity and
                  security of Your information against loss, theft, unauthorized
                  access, disclosure, reproduction, use or amendment. To achieve
                  the same, We use reasonable security practices and procedures
                  as mandated under applicable laws for the protection of Your
                  information. Information You provide to Us may be stored on
                  Our secure servers located within or outside India.
                  <br />
                  <br />
                  However, You understand and accept that there’s no guarantee
                  that data transmission over the Internet will be completely
                  secure and that any information that You transmit to Us is at
                  Your own risk. We assume no liability for any disclosure of
                  information due to errors in transmission, unauthorized third
                  party access to our Platform and data bases or other acts of
                  third parties, or acts or omissions beyond our reasonable
                  control and you shall not be entitled to hold MoneyMonk
                  responsible for any breach of security.
                </p>
                <h3 className="mt-4 mb-2">
                  4. ACCESSING YOUR INFORMATION / CONTACTING US
                </h3>{" "}
                <p style={{ textAlign: "start" }}>
                  At any point of time Users can choose to edit/modify or
                  delete/withdraw any Personal Information shared for use of the
                  Platform. Please note that deleting or withdrawing information
                  may affect the Services we provide to you. In case of
                  modification of Personal Information, Users will be required
                  to furnish supporting documents relating to change in Personal
                  Information for the purpose of verification by the Company.
                </p>
                <h3 className="mt-4 mb-2">5. DATA RETENTION AND DELETION</h3>{" "}
                <p style={{ textAlign: "start" }}>
                  We take the protection of your personal data seriously and
                  implement appropriate security measures to safeguard it from
                  unauthorized access, misuse, and disclosure. The level of
                  security measures we employ depends on the type of data and
                  how we process it. We retain certain information about you to
                  ensure a seamless experience, provide support when needed, and
                  manage your account. Additionally, we retain your data to
                  detect, prevent, investigate, and mitigate any fraudulent or
                  illegal activities that may occur during your use of our
                  services. The duration for which we retain your data is
                  determined by the necessity to provide our services to you.
                  <br />
                  <br />
                  All records pertaining to KYC information of clients,
                  documents produced for loan applications, client-signed
                  documents, policy particulars, customer complaint details,
                  loan application/disbursal specifics, and transaction
                  histories must be retained for a minimum of ten years from
                  either (a) the date of the last transaction recorded, or (b)
                  the policy expiration date, whichever occurs later. In cases
                  where disputes, claims, or similar matters are raised by
                  customers or other parties within the aforementioned retention
                  period, whether in the form of representations, complaints, or
                  legal proceedings in any court or recognized forum, all
                  relevant records must be maintained until the final resolution
                  of the dispute.
                  <br />
                  <br />
                  The retention period in such instances will thus extend to
                  either the final resolution or decision of the dispute, or ten
                  years from the date of the last transaction recorded, or ten
                  years from the policy expiration date, whichever is later. We
                  retain your Personal Information as per our Record and Data
                  Retention Policy for as long as your registration is valid
                  and/or any Outstanding Amounts are due, and as long as any
                  active service is being availed by you. If you wish to have
                  your data deleted, you can make a written request to our
                  customer care from your registered email id.
                  <br />
                  <br />
                  However, please note that there might be a delay in deleting
                  Personal Information from our servers. After deletion, you may
                  no longer be able to use our services. It might take up to 5
                  working days to delete your data from our systems. Please note
                  that after the deletion of your account, we may retain and
                  utilize your basic personal information, such as your name,
                  contact number, transactional details, and address, to fulfill
                  our legal obligations, resolve disputes, and enforce our
                  agreements. All these actions are carried out in accordance
                  with applicable laws, rules, and regulations. Our data
                  retention and deletion policy is in consonance with the
                  applicable laws and guidelines of the RBI.
                  <br />
                  <br />
                  We take the protection of your personal data seriously. We
                  implement appropriate security measures to safeguard your
                  information from unauthorized access, misuse, and disclosure.
                  The level of security measures we employ depends on the type
                  of data and how we process it. We retain certain information
                  about you to ensure a seamless experience, provide support
                  when needed, and manage your account. Additionally, we retain
                  your data to detect, prevent, investigate, and mitigate any
                  fraudulent or illegal activities that may occur during your
                  use of our services.
                  <br />
                  <br />
                  The duration for which we retain your data is determined by
                  the necessity to provide our services to you. We may also
                  retain and utilize your basic personal information, such as
                  your name, contact number, transactional details, and address,
                  to fulfill our legal obligations, resolve disputes, and
                  enforce our agreements. All these actions are carried out in
                  accordance with applicable laws, rules and regulations.
                  <br />
                  <br />
                  If you wish to have your data deleted, you can make a written
                  request to our customer care. However, please note that after
                  deletion, you may no longer be able to use our services.
                </p>
                <h3
                  className="mt-4 mb-2"
                  style={{ textDecoration: "underline" }}
                >
                  6.YOUR PRIVACY CONTROLS
                </h3>{" "}
                <p style={{ textAlign: "start" }}>
                  You have certain choices regarding the information we collect
                  and how it is used:
                  <ul style={{ padding: 20 }}>
                    <li className="mb-1">
                      • Device-level settings: Your device may have controls
                      that determine what information we collect. For example,
                      you can modify permissions on your Android device for
                      access to Camera or Audio permissions.
                    </li>
                    <li className="mb-1">• Delete the App from your device</li>
                    <li>
                      • You can also request to remove content from our servers
                      based on applicable law or by writing to our Grievance
                      Officer.
                    </li>
                  </ul>
                </p>
                <h3
                  className="mt-4 mb-2"
                  style={{ textDecoration: "underline" }}
                >
                  7. SECURITY PRECAUTIONS
                </h3>{" "}
                <p style={{ textAlign: "start" }}>
                  The Platform intends to protect your information and to
                  maintain its accuracy as confirmed by you. We implement
                  reasonable physical, administrative and technical safeguards
                  to help us protect your information from unauthorized access,
                  use and disclosure. For example, we encrypt all information
                  when we transmit over the internet. We also require that our
                  registered third-party service providers protect such
                  information from unauthorized access, use and disclosure.
                  <br />
                  <br />
                  Our Platform has stringent security measures in place to
                  protect the loss, misuse and alteration of information under
                  control. We endeavour to safeguard and ensure the security of
                  the information provided by you. We use Secure Sockets Layers
                  (SSL) based encryption, for the transmission of the
                  information, which is currently the required level of
                  encryption in India as per applicable law. We blend security
                  at multiple steps within our products with the state of the
                  art technology to ensure our systems maintain strong security
                  measures and the overall data and privacy security design
                  allow us to defend our systems ranging from low hanging issues
                  up to sophisticated attacks.
                  <br />
                  <br />
                  In addition, the Website and App have been certified for the
                  following security certifications:
                  <br />
                  <br />
                  We aim to protect from unauthorized access, alteration,
                  disclosure or destruction of information we hold, including:
                  <ul style={{ padding: 20 }}>
                    <li className="mb-1">
                      • We use encryption to keep your data private while in
                      transit;
                    </li>
                    <li className="mb-1">
                      • We offer security feature like an OTP verification to
                      help you protect your account
                    </li>
                    <li className="mb-1">
                      • We review our information collection, storage, and
                      processing practices, including physical security
                      measures, to prevent unauthorized access to our systems.
                    </li>
                    <li className="mb-1">
                      • We restrict access to personal information to our
                      employees, contractors, and agents who need that
                      information in order to process it. Anyone with this
                      access is subject to strict contractual confidentiality
                      obligations and may be disciplined or terminated if they
                      fail to meet these obligations
                    </li>
                    <li className="mb-1">
                      • Compliance & Cooperation with Regulations and applicable
                      laws
                    </li>
                    <li className="mb-1">
                      • We regularly review this Privacy Policy and make sure
                      that we process your information in ways that comply with
                      it.
                    </li>
                    <li className="mb-1"> • Data Transfers.</li>
                    <li>
                      • We ensure that the Aadhaar number is not stored or
                      disclosed in any manner.
                    </li>
                  </ul>
                  We or our affiliates maintain your information on servers
                  located in India. Data protection laws vary among countries,
                  with some providing more protection than others. We also
                  comply with certain legal frameworks relating to the transfer
                  of data as mentioned and required under the Information
                  Technology Act, 2000 and rules made thereunder.
                  <br />
                  <br />
                  When we receive formal written complaints, we respond by
                  contacting the person who made the complaint. We work with the
                  appropriate regulatory authorities, including local data
                  protection authorities, to resolve any complaints regarding
                  the transfer of your data that we cannot resolve with you
                  directly.
                </p>
                <h3
                  className="mt-4 mb-2"
                  style={{ textDecoration: "underline" }}
                >
                  8. THIRD PARTY WEBSITES
                </h3>{" "}
                <p style={{ textAlign: "start" }}>
                  With this Policy We’re only addressing the disclosure and use
                  of data collected by us. If you visit any websites through the
                  links on the MoneyMonk Platform, please ensure you go through
                  the privacy policies of each of those websites. Their data
                  collection practices and policies might differ from this
                  policy, and MoneyMonk does not control or assume any liability
                  for those policies.
                </p>
                <h3
                  className="mt-4 mb-2"
                  style={{ textDecoration: "underline" }}
                >
                  9. PHISHING
                </h3>{" "}
                <p style={{ textAlign: "start" }}>
                  "Phishing" usually occurs when users of a website are induced
                  by an individual/entity into divulging sensitive personal data
                  by using fraudulent websites and/ or e-mail addresses. In the
                  event You provide information to a website or respond to an
                  e-mail which does not belong to Us or is not connected with Us
                  in any manner, You will be a victim of Phishing. We do not
                  send e-mails requesting a user for payment information, user
                  name or passwords. However, We may verify the user name,
                  password etc. provided by You from time to time.
                </p>
                <h3
                  className="mt-4 mb-2"
                  style={{ textDecoration: "underline" }}
                >
                  10. SEVERABILITY AND EXCLUSION
                </h3>{" "}
                <p style={{ textAlign: "start" }}>
                  We have taken every effort to ensure that this Policy adheres
                  with the applicable laws. The invalidity or unenforceability
                  of any part of this Policy shall not prejudice or affect the
                  validity or enforceability of the remainder of this Policy.
                  This Policy does not apply to any information other than the
                  information collected by MoneyMonk through the Platform. This
                  Policy shall be inapplicable to any unsolicited information
                  You provide Us through the Platform or through any other
                  means. This includes, but is not limited to, information
                  posted in any public areas of the Website / App. All
                  unsolicited information shall be deemed to be non-confidential
                  and the Company shall be free to use and/ or disclose such
                  unsolicited information without any limitations.
                </p>
                <h3
                  className="mt-4 mb-2"
                  style={{ textDecoration: "underline" }}
                >
                  11. NO WAIVER
                </h3>{" "}
                <p style={{ textAlign: "start" }}>
                  The rights and remedies of available under this Policy may be
                  exercised as often as necessary and are cumulative and not
                  exclusive of rights or remedies provided by law. It may be
                  waived only in writing. Delay in exercising or non-exercise of
                  any such right or remedy does not constitute a waiver of that
                  right or remedy, or any other right or remedy.
                </p>
                <h3
                  className="mt-4 mb-2"
                  style={{ textDecoration: "underline" }}
                >
                  12. YOUR CONSENT
                </h3>{" "}
                <p style={{ textAlign: "start" }}>
                  By using the Platform and by providing your information, you
                  consent to the collection, sharing, disclosure and usage of
                  the information that you disclose on the Platform in
                  accordance with this Privacy Policy.
                  <br />
                  <br />
                  If we decide to change our Privacy Policy, we will post those
                  changes on this page so to make you aware of the information
                  we collect, how we use it, and under what circumstances we
                  share and disclose it.
                </p>
                <h3
                  className="mt-4 mb-2"
                  style={{ textDecoration: "underline" }}
                >
                  13. GRIEVANCE REDRESSAL OFFICER
                </h3>{" "}
                <p style={{ textAlign: "start" }}>
                  If you require any information or clarification regarding the
                  use of Your personal information or this Privacy Policy,
                  please write to:
                  <br />
                  <span className="fw-5">Name: </span> Mr. K. Sai Ram Reddy{" "}
                  <br /> <span className="fw-5">Address: </span> The Platina,
                  B-406, Sy No. 132, 134, H. No. 4-50/1, Gachibowli, K.V.
                  Rangareddy, Seri Lingampally, Telangana – 500032. <br />{" "}
                  <span className="fw-5">Email: </span>
                  gro[at]monkcapital[dot]in <br />
                  <span className="fw-5">Phone: </span> 63091 - 48333 Time: MON
                  - SAT : 09:30 AM - 06:00 PM <br />
                  The Company is based in India. By browsing/using the platform,
                  you hereby acknowledge that the Company is not responsible or
                  liable in any manner to comply with any local laws of your
                  territory except India.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default PrivacyPolicyContent;
